import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';

import { AppRouterModule } from '@app/router.module';

import { AppMainComponent } from './main/main.component';
import { LayoutOverlappedModule } from './overlapped/overlapped.module';

@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        AppRouterModule,
        HelperBoxModule,
        LayoutOverlappedModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        AppMainComponent
    ],
    exports: [
        AppMainComponent
    ],

})
export class LayoutModule { }
